export function useIsMobile(): boolean {
  if (typeof navigator === "undefined") return false;
  if (/Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }
  // iPadOS Safari reports a "Macintosh" user-agent (desktop-class) but, unlike a
  // real Mac, exposes touch points — so a touch-capable "Mac" is really an iPad.
  return navigator.maxTouchPoints > 0 && /Macintosh/i.test(navigator.userAgent);
}
